import React from "react";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { Quote, ShieldCheck } from "lucide-react";
import { useI18n } from "../i18n";

const TESTIMONIALS = [
    {
        quote:
            "Centralizar todo el ecosistema digital en un único partner ha sido la decisión más rentable del último año.",
        author: "Director General",
        company: "Industria agroalimentaria",
    },
    {
        quote:
            "Migración cloud, ENS y soporte 24/7 ejecutados sin sobresaltos. Un equipo realmente accesible.",
        author: "CIO",
        company: "Distribución logística",
    },
    {
        quote:
            "Pasamos de procesos manuales a automatización con IA en menos de tres meses. Recomendable 100%.",
        author: "Head of Operations",
        company: "Servicios profesionales",
    },
];

const CLIENTS = ["ANPADA", "LAREDO", "AGENJO", "GRUPO LA", "TECH OPS", "LOGISTIC", "AGRO+"];

export default function Trust() {
    const { dict, t } = useI18n();
    const certs = dict.trust.certs;

    return (
        <section id="trust" data-testid="trust-section" className="section-pad relative scroll-mt-24">
            <div className="container-page">
                <div className="mb-12 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                    <div className="max-w-2xl">
                        <span className="eyebrow">{t("trust.eyebrow")}</span>
                        <h2
                            data-testid="trust-title"
                            className="mt-5 text-4xl md:text-5xl font-semibold tracking-tighter"
                        >
                            {t("trust.title")}
                        </h2>
                    </div>
                    <div className="flex flex-wrap gap-2">
                        {certs.map((c) => (
                            <span
                                key={c}
                                data-testid={`cert-${c}`}
                                className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.03] px-3.5 py-1.5 text-xs font-medium text-white/75"
                            >
                                <ShieldCheck className="h-3.5 w-3.5 text-brand-glow" />
                                {c}
                            </span>
                        ))}
                    </div>
                </div>

                {/* Clients marquee */}
                <div
                    data-testid="clients-marquee"
                    className="relative my-10 border-y border-white/[0.06] py-8"
                >
                    <Marquee gradient gradientColor="#050505" gradientWidth={120} speed={40} pauseOnHover>
                        {CLIENTS.concat(CLIENTS).map((name, i) => (
                            <span
                                key={`${name}-${i}`}
                                className="mx-10 font-display text-xl md:text-2xl tracking-[0.2em] text-white/30 hover:text-white/80 transition-colors"
                            >
                                {name}
                            </span>
                        ))}
                    </Marquee>
                </div>

                {/* Testimonials */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                    {TESTIMONIALS.map((tm, idx) => (
                        <motion.figure
                            key={idx}
                            data-testid={`testimonial-${idx}`}
                            initial={{ opacity: 0, y: 16 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.5, delay: idx * 0.08 }}
                            className="card-surface p-7"
                        >
                            <Quote className="h-5 w-5 text-brand-glow mb-4 opacity-80" />
                            <blockquote className="text-base text-white/85 leading-relaxed">
                                "{tm.quote}"
                            </blockquote>
                            <figcaption className="mt-5 text-xs text-white/50">
                                <span className="font-medium text-white/80">{tm.author}</span> · {tm.company}
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
